module.exports = __webpack_public_path__ + "img/Région-bretagne-logo.818b5bda.svg";